































































import { Component } from 'vue-property-decorator';
import SearchResultsBaseComponent from '@/components/SearchResults/SearchResultsBaseComponent.vue';
import SearchResultElement from '@/models/SearchResultElement';
import { FilterGetter, SearchGetter } from '@/store/getters';
import { SearchAction } from '@/store/actions';
import NoResultsComponent from '@/components/SearchResults/NoResultsComponent.vue';
import HtmlDataHelper from '@/helpers/HtmlDataHelper';
import TileTrackerHelper from '@/helpers/TileTrackerHelper';

@Component({
  name: 'product-grid-component',
  computed: {
    HtmlDataHelper() {
      return HtmlDataHelper;
    },
  },
  components: { 'no-results-component': NoResultsComponent },
})
export default class ProductGridComponent extends SearchResultsBaseComponent {
  get searchResults(): Array<SearchResultElement> {
    return this.$store.getters[SearchGetter.SearchResults].length
      ? this.$store.getters[SearchGetter.SearchResults]
      : this.$store.getters[SearchGetter.SearchSuggestions].elements;
  }

  get isLoading(): boolean {
    return this.$store.getters[SearchGetter.IsLoading];
  }

  get showShowMore(): boolean {
    return !this.isLoading
      && this.$store.getters[SearchGetter.SearchResults].length
      && this.searchResults.length < this.$store.getters[SearchGetter.TotalNumberOfResults];
  }

  private tileTracker = new TileTrackerHelper(new HtmlDataHelper());

  public gridResultClick(searchResult: SearchResultElement, index: number) {
    if (searchResult.type === 'product') {
      this.tileTracker.sendGoogleDataLayer({
        event: 'eec.productClick',
        ecommerce: {
          currencyCode: 'currencyCode',
          click: {
            actionField: {
              list: `resultpage|${this.hasFilters()}`,
            },
            products: [{
              category: HtmlDataHelper.createAnalyticsCategory(searchResult),
              name: `${searchResult.itemId}|${searchResult.title}`,
              position: index,
            }],
          },
        },
      });
    } else {
      this.tileTracker.sendGoogleDataLayer({
        event: 'eec.promotionClick',
        ecommerce: {
          promoClick: {
            promotions: [
              {
                id: `resultpage|${this.hasFilters()}`,
                name: `${searchResult.itemId}|${searchResult.title}`,
                creative: searchResult.urlPath,
                position: index,
              },
            ],
          },
        },
      });
    }
  }

  private hasFilters() {
    let hasFilters = 'Not Filtered';
    if (this.$store.getters[FilterGetter.AppliedFilterOptions].size > 0) {
      hasFilters = 'Filtered';
    }
    return hasFilters;
  }

  private showMore() {
    if (!this.isLoading) {
      // this.$store.dispatch(AnalyticsAction.ClickShowMore);
      this.$store.dispatch(SearchAction.LoadMore);
    }
  }
}
